<template>
  <div class="btn-checkout">
    <div
      :id="id"
      class="btn-checkout-popover"
      v-if="conditions && popover !== ''"
      v-b-popover.hover.top="popover"
    ></div>
    <div class="btn-wrap" v-b-hover="handle_popover">
      <vb-button
        ref="trigger_checkout"
        :vb_options="{ variant: 'info', block: fullwidth, disabled: conditions }"
        @click="handle_data_emit"
      >
        {{ copy }}
      </vb-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'btn-checkout',
  components: {},
  props: {
    id: {
      type: String,
    },
    conditions: {
      type: Boolean,
    },
    popover: {
      type: String,
      default: '',
    },
    fullwidth: {
      type: Boolean,
      default: true,
    },
    copy: {
      type: String,
      default: 'Vai al Checkout',
    },
  },
  emits: ['handle_data'],
  created() {},
  methods: {
    handle_data_emit() {
      this.$emit('handle_data');
    },
    handle_popover(value) {
      if (value) this.$root.$emit('bv::show::popover', this.id);
      else this.$root.$emit('bv::hide::popover', this.id);
    },
    trigger() {
      this.$nextTick(() => {
        this.$refs.trigger_checkout.click();
      });
    },
  },
};
</script>

<style lang="scss">
.btn-checkout {
  position: relative;

  .btn-checkout-popover {
    position: absolute;
    z-index: 1;
    visibility: hidden;
    left: 0;
    right: 0;
    top: 0;
    &:after {
      content: '\00a0';
    }
  }
  .btn-wrap {
    position: relative;
    z-index: 2;
  }
}
</style>
